import React, { useState, useEffect } from "react";
import { Container, Grid, Box, Typography, Button } from "@mui/material";
import PlanCard from "./ScheduleAnalysis";
import http from "../../utils/http-common";

const AnalysisDashboard = () => {
  const [plans, setPlans] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");


  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await http.post("master_service/schedule/analysis/report/dashboard");


        const data = response.data;

        const TOTAL_POINTS = 12;


        const formattedPlans = data.map((item) => {

          const passedPoints = Math.round((item.success_percentage / 100) * TOTAL_POINTS);

          return {
            id: item.plan_id,
            name: item.plan_name || "No Name",
            description: item.plan_description || "No Description",
            score: item.success_percentage || 0,
            note: item.passed_rules,
            members: [
              item.users?.uploaded_picture_path || ""
            ],
          };
        });
        setPlans(formattedPlans);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPlans();
  }, []);


  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const filteredPlans = plans.filter((plan) =>
    plan.name.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const sortedPlans = [...filteredPlans].sort((a, b) =>
    sortOrder === "asc" ? a.score - b.score : b.score - a.score
  );

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        // paddingTop: 3,
      }}
    >

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: 2
        }}
      >
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "20px",
            fontWeight: 600,
            lineHeight: "21px",
            textAlign: "left",
          }}
        >
          Schedule Analysis Dashboard
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>

          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "200px",
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              padding: "8px 2px 8px 20px",
              borderRadius: "4px",
              border: "1px solid lightgray",
              outline: "none",
            }}
          />

          <button
            style={{
              padding: "8px 15px",
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 600,
              color: "gray",
              backgroundColor: "#FFF",
              border: "1px solid lightgray",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={toggleSortOrder}
          >
           Sort
          </button>

        </Box>
      </Box>


      <Container maxWidth="xl" sx={{ py: 5 }}>
        <Grid container spacing={5} justifyContent="flex-start">
          {sortedPlans.map((plan) => (
            <Grid item xs={12} sm={6} md={3} key={plan.id}>
              <PlanCard {...plan} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AnalysisDashboard;
